"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Option = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var Checkbox_1 = require("./Checkbox");
var SelectContext_1 = require("./SelectContext");
var OptionWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  cursor: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n\n  &:not(:last-child) {\n    margin-bottom: 2px;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  padding: ", ";\n  border-radius: ", ";\n  cursor: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n\n  &:not(:last-child) {\n    margin-bottom: 2px;\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), helios_styles_1.text.default, helios_styles_1.body.regular.md.fontFamily, helios_styles_1.body.regular.md.fontWeight, helios_styles_1.body.regular.md.fontSize, helios_styles_1.body.regular.md.lineHeight, helios_styles_1.spacing.lg, helios_styles_1.borderRadius.md, function (props) { return props.selected ? 'default' : 'pointer'; }, helios_styles_1.background.default, function (props) {
    return props.highlighted
        ? "0px 0px 0px 3px rgba(34, 139, 230, 0.6),\n  0px 0px 0px 1px ".concat(helios_styles_1.shadow.focusVisible[1].color)
        : 'none';
}, function (props) { return (props.highlighted ? 10 : 0); }, function (props) { return props.selected
    ? 'transparent'
    : "".concat(helios_styles_1.background.defaultHover); });
var CheckboxOptionWrapper = (0, styled_components_1.default)(OptionWrapper)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: ", ";\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: ", ";\n"])), helios_styles_1.spacing.md);
var OptionContent = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var Option = function (_a) {
    var children = _a.children, value = _a.value, className = _a.className;
    var _b = (0, react_1.useContext)(SelectContext_1.SelectContext), idPrefix = _b.idPrefix, visualFocusId = _b.visualFocusId, isMultiselect = _b.isMultiselect, selectedValues = _b.selectedValues, setSelection = _b.setSelection;
    var isSelected = selectedValues.includes(value);
    var handleClick = function (event) {
        setSelection(children, event, value);
    };
    var optionTextSpacesRemoved = value.replace(' ', '_');
    var id = "".concat(idPrefix, "-option-").concat(optionTextSpacesRemoved);
    var wrapperProps = {
        id: id,
        className: className,
        onClick: handleClick,
        role: 'option',
        'aria-selected': isSelected,
        highlighted: visualFocusId === id,
        selected: isSelected,
        'data-cv-test': "".concat(value, "-option")
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isMultiselect ? ((0, jsx_runtime_1.jsxs)(CheckboxOptionWrapper, __assign({}, wrapperProps, { children: [isSelected ? (0, jsx_runtime_1.jsx)(Checkbox_1.CheckboxOn, {}) : (0, jsx_runtime_1.jsx)(Checkbox_1.CheckboxOff, {}), (0, jsx_runtime_1.jsx)(OptionContent, { children: children })] }))) : ((0, jsx_runtime_1.jsx)(OptionWrapper, __assign({}, wrapperProps, { children: children }))) }));
};
exports.Option = Option;
var templateObject_1, templateObject_2, templateObject_3;
